// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { hiddenMixin } from '../../../common/styled';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var HelpContainer = styled.div({
  display: 'flex',
  marginLeft: 'auto',
  marginRight: 0,
  flexShrink: 0,
  padding: "0 ".concat("var(--ds-space-100, 8px)"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> * + *': {
    marginLeft: "var(--ds-space-200, 16px)"
  }
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (props) {
  return props.isVisible ?
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  css({
    visibility: 'visible',
    opacity: 1,
    transition: 'opacity 250ms cubic-bezier(0.15, 1, 0.3, 1)'
  }) :
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  css(hiddenMixin, {
    opacity: 0
  });
});